



























































import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import BannerTmp from "./../../common/banner/bannerTop.vue";
import EffectTmp from "./../../common/effect_footer/effect_footer.vue";
@Component({
    components:{
        BannerTmp,EffectTmp
    }
})
export default class travelIndex extends Vue {
    //向子组件传值
    //protected 修饰的属性或者方法是私有的，但它的子组件可以访问到
    protected bannerData: object = {
        imgUrl: require('../../../../static/images/banner_travel.png'),
        title: '员工差旅报销',
        subTitle: '轻松助力业务降本增效'
    };
    public list: any= [
        {imgUrl: require('../../../assets/images/solution/travel/travel_1.png'), title: '流程繁琐', des: '报销过程重复度高，操作流程繁琐，耗时长。'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_2.png'), title: '容易出错', des: '人工填报可能出现错误，效率低质量差。'},
    ];

    public frontArr: any= [
        {imgUrl: require('../../../assets/images/solution/travel/travel_5.svg'), number: 1, text: '准备报销素材'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_6.svg'), number: 2, text: '登录报销系统'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_7.svg'), number: 3, text: '填写报销单'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_8.svg'), number: 4, text: '输入发票信息'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_9.svg'), number: 5, text: '核对发票及销单信息'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_10.svg'), number: 6, text: '提交报销单'}
    ];
    public afterArr: any= [
        {imgUrl: require('../../../assets/images/solution/travel/travel_11.svg'), number: 1, text: '准备报销素材'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_12.svg'), number: 2, text: '登录报销系统'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_13.svg'), number: 3, text: '填写报销单'},
        {imgUrl: require('../../../assets/images/solution/travel/travel_14.svg'), number: 4, text: '自动识别发票信息并输入系统',
        icon: require('../../../assets/images/solution/OCR.svg')},
        {imgUrl: require('../../../assets/images/solution/travel/travel_15.svg'), number: 5, text: '提交报销单'}
    ];

}

